var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharePlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.765 12.329h11.99V8.636a.336.336 0 01.672 0v3.693a.671.671 0 01-.671.671H.67A.671.671 0 010 12.329V8.683a.382.382 0 11.765 0v3.646zM9.515 3.6L7.336 1.424a.671.671 0 11.95-.95l3.09 3.091a1 1 0 010 1.415l-3.09 3.09a.671.671 0 11-.95-.95l2.177-2.176H2.685a.671.671 0 110-1.343h6.83z",
    fill: "#7A8D8F"
  })));
}
export default SvgSharePlaylist;